export const EVENTOS_INTERNOS = {
  Vacaciones: { color: '#ffe082', fondo: '#fef3c7', borde: '#f59e0b', texto: '#92400e', badge: 'bg-blue-100 text-blue-700' },
  'Trabajo interno': { color: '#ab47bc', fondo: '#f3e5f5', borde: '#ab47bc', texto: '#6a1b9a', badge: 'bg-amber-100 text-amber-700' },
  'Día Feriado': { color: '#38bdf8', fondo: '#e0f2fe', borde: '#0284c7', texto: '#075985', badge: 'bg-sky-100 text-sky-700' },
};

export const normalizarTipoEvento = (tipo) => {
  const normalizar = valor => String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  return Object.keys(EVENTOS_INTERNOS).find(valor => normalizar(valor) === normalizar(tipo)) || tipo;
};

export const esEventoInterno = tipo => Object.prototype.hasOwnProperty.call(EVENTOS_INTERNOS, normalizarTipoEvento(tipo));
